import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Phone, MessageCircle, Trash2, Check } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function EnquiriesTab({ onRead }) {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/enquiries").then((r) => setList(r.data)); }, []);
  const markRead = async (e) => {
    try { await api.patch(`/enquiries/${e.id}`); setList((l) => l.map((x) => (x.id === e.id ? { ...x, read: true } : x))); onRead(); } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (e) => {
    if (!window.confirm(`Delete enquiry from ${e.name}?`)) return;
    try { await api.delete(`/enquiries/${e.id}`); setList((l) => l.filter((x) => x.id !== e.id)); if (!e.read) onRead(); } catch (err) { toast.error(errMsg(err)); }
  };
  if (!list) return <p className="text-sm text-slate-500">Loading…</p>;
  if (!list.length) return <p className="rounded-xl border border-slate-800 p-10 text-center text-sm text-slate-500" data-testid="enquiries-empty">No enquiries yet. Visitors' messages from your website appear here.</p>;
  return (
    <div className="space-y-3" data-testid="enquiries-list">
      {list.map((e, i) => (
        <div key={e.id} className={`rounded-xl border p-4 flex flex-wrap gap-4 justify-between ${e.read ? "border-slate-800 bg-slate-900/40" : "border-amber-500/40 bg-amber-500/5"}`} data-testid={`enquiry-${i}`}>
          <div className="min-w-0">
            <p className="font-semibold">{e.name} <span className="font-mono text-xs text-slate-400 ml-2">{e.phone}</span>{!e.read && <span className="ml-2 text-[10px] font-mono uppercase text-amber-300">new</span>}</p>
            {e.product && <p className="text-xs text-amber-300 mt-0.5">About: {e.product}</p>}
            {e.message && <p className="text-sm text-slate-300 mt-1 whitespace-pre-line">{e.message}</p>}
            <p className="text-[11px] text-slate-500 mt-1">{new Date(e.created_at).toLocaleString()}</p>
          </div>
          <div className="flex items-start gap-1.5">
            <a href={`tel:${e.phone}`} className="cf-btn-ghost h-8 text-xs" data-testid={`enquiry-call-${i}`}><Phone size={12} /> Call</a>
            <a href={`https://wa.me/${e.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="cf-btn-ghost h-8 text-xs" data-testid={`enquiry-whatsapp-${i}`}><MessageCircle size={12} /> WhatsApp</a>
            {!e.read && <button onClick={() => markRead(e)} className="cf-btn-ghost h-8 text-xs" data-testid={`enquiry-read-${i}`}><Check size={12} /> Mark read</button>}
            <button onClick={() => remove(e)} className="p-2 text-slate-500 hover:text-red-400" data-testid={`enquiry-delete-${i}`}><Trash2 size={13} /></button>
          </div>
        </div>
      ))}
    </div>
  );
}
